<template>
  <div>
    <div>
      <!-- Home page content -->
      <main role="main">
        
        <div class="container text-center">
          <div class="my-md-5 my-3">
            <section class="wrapper">
              <component :is="WidgetComponent" :campaign-id="$t('CampaignID')"></component>
            </section>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>
<script>
import CampaignWidgets from '../Home/Homepagecomponents/CampaignWidgets.vue';

export default {
  components: { CampaignWidgets },
  props: {

  },
  data() {
    return {
      showComponent: false,
      WidgetComponent: CampaignWidgets,
    };
  },
};
</script>

<style scoped>

</style>


